module.exports = __webpack_public_path__ + "img/159cbc8.png";